import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isUserAuthenticated, isCurrentUserSuperUser, isCurrentUserStaffOrSuperAdmin } from '../selectors/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiresSuperUser?: boolean;
  requiresStaffOrSuperUser?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiresSuperUser = false, requiresStaffOrSuperUser = false }) => {
  const location = useLocation();
  const isAuthenticated = useSelector(isUserAuthenticated);
  const isUserSuperUser = useSelector(isCurrentUserSuperUser);
  const isUserStaffOrSuper = useSelector(isCurrentUserStaffOrSuperAdmin);

  if (!isAuthenticated) {
    return <Navigate to="/account/login" state={{ from: location }} replace />;
  }

  if (requiresSuperUser && !isUserSuperUser) {
    return <Navigate to="/app/access-denied" replace />;
  }

  if (requiresStaffOrSuperUser && !isUserStaffOrSuper) {
    return <Navigate to="/app/access-denied" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
